var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"product-payment txtButtonAddBasket-paypal",attrs:{"loading":_vm.isLoading},on:{"click":_vm.orderCreate}},[_vm._v(_vm._s(_vm.text)+"\n    "),_c('img',{attrs:{"src":_vm.image,"alt":_vm.alternate}})])}
var staticRenderFns = []

export { render, staticRenderFns }